import { Component, OnInit } from '@angular/core';
import { ParkingsService } from '../../service/main/parkings.service';
import { Parking, Sensor, UpdateSensor } from '../../entity';
import { ToastrService } from '../../service/common/toastr.service';

@Component({
    selector: 'app-sensors-cmp',
    templateUrl: './sensors.component.html'
})

export class SensorsComponent implements OnInit {
    sensors: Array<Sensor> = new Array<Sensor>();
    parkings: Array<Parking> = new Array<Parking>();
    selectedParking: Parking;
    sensor: Sensor = null;
    editingSensor: Sensor;
    currentPage = 1;
    sensorNoFilter: Sensor = {
        RegistrationNumber: ''
    };

    constructor(
        private parkingService: ParkingsService,
        private toastr: ToastrService
    ) { }

    ngOnInit() {
        this.refreshParkings();
    }

    refreshParkings() {
        this.parkingService.getByAdmin().subscribe(result => {
            if (result && result.length) {
                const parkings = new Array<Parking>();
                result.forEach(item => {
                    const parking = new Parking();
                    parking.fromObject(item);

                    parkings.push(parking);
                });

                this.selectedParking = parkings[0];
                this.parkings = parkings;
                this.refreshSensors(this.selectedParking.ParkingID);
            }
        });
    }

    refreshSensors(parkingId: number) {
        this.parkingService.getSensorsByParkingId(parkingId).subscribe(result => {
            if (result && result.length) {
                const sensors = new Array<Sensor>();
                result.forEach(item => {
                    const sensor = new Sensor();
                    sensor.fromObject(item);

                    sensors.push(sensor);
                });

                this.sensors = sensors;
            }
        });
    }

    selectParking(index: number) {
        this.selectedParking = this.parkings[index];
        this.sensors = new Array<Sensor>();
        this.refreshSensors(this.selectedParking.ParkingID);
    }

    createSensor() {
        this.sensor = new Sensor();
    }

    cancelCreate() {
        this.sensor = null;
    }

    registerSensor() {
        this.sensor.ParkingID = this.selectedParking.ParkingID;
        this.parkingService.registerSensor(this.sensor).subscribe(result => {
            const sensor = new Sensor();
            sensor.fromObject(result);

            this.sensors.unshift(sensor);
            this.sensor = null;
            this.toastr.success(`Sensor ${sensor.RegistrationNumber} succesfully added!`);
        }, error => {
            this.toastr.error(`A error has occurred while adding sensor: ${this.sensor.RegistrationNumber}.`);
        });
    }

    editSensor(sensor: Sensor) {
        let canEdit = true;
        this.sensors.forEach(item => {
            if (item.IsEditable === true) {
                canEdit = false;
            }
        });

        if (canEdit) {
            this.editingSensor = new Sensor();
            this.editingSensor.fromObject(sensor);
            sensor.IsEditable = true;
        }
    }

    cancelEdit(sensor: Sensor) {
        sensor.fromObject(this.editingSensor);
        sensor.IsEditable = false;
    }

    updateSensorParking(index: number, sensor: Sensor) {
        sensor.ParkingID = this.parkings[index].ParkingID;
    }

    updateSensor(sensor: Sensor) {
        const uSensor = new UpdateSensor(
            sensor.SensorID,
            sensor.ParkingID,
            sensor.RegistrationNumber
        );

        this.parkingService.updateSensor(uSensor).subscribe(result => {
            if (result) {
                const editedSensor = new Sensor();
                editedSensor.fromObject(result);

                if (editedSensor.ParkingID !== this.selectedParking.ParkingID) {
                    const index = this.sensors.findIndex(item => item.RegistrationNumber === editedSensor.RegistrationNumber);
                    this.sensors.splice(index, 1);
                }

                sensor.IsEditable = false;
                this.toastr.success(`Sensor ${sensor.RegistrationNumber} succesfully updated!`);
            }
        }, error => {
            this.toastr.error(`A error has occurred while updating sensor: ${sensor.RegistrationNumber}.`);
        });
    }

    deleteSensor(sensor: Sensor) {
        this.parkingService.deleteSensor(sensor.SensorID).subscribe(result => {
            const index = this.sensors.findIndex(item => item.SensorID === sensor.SensorID);
            this.sensors.splice(index, 1);
            this.toastr.success(`Sensor ${sensor.RegistrationNumber} succesfully removed!`);
        }, error => {
            this.toastr.error(`A error has occurred while removing sensor: ${sensor.RegistrationNumber}.`);
        });
    }
}
